import { Mail, Phone, MessageCircle, Instagram, Facebook } from "lucide-react";
import { BRAND } from "@/lib/site-data";

export default function Footer() {
  const whatsappHref = `https://wa.me/${BRAND.whatsappNumber}`;
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F3D3E] text-[#F4EDE4] pt-20 pb-10 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 10% 0%, #7A8F6B 0, transparent 40%), radial-gradient(circle at 90% 100%, #2C7A7B 0, transparent 40%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logoUrl}
              alt="DreamFly Travels logo"
              className="block size-14 object-contain shrink-0"
            />
            <div className="flex flex-col leading-none">
              <span className="font-display text-3xl sm:text-4xl">DreamFly</span>
              <span className="uppercase text-[10px] sm:text-[11px] tracking-[0.3em] text-[#7A8F6B] mt-1">
                Travels
              </span>
            </div>
          </div>
          <p className="mt-5 text-[#F4EDE4]/70 max-w-sm leading-relaxed">
            Curated international and domestic travel experiences. Luxury at
            sensible prices, backed by global DMC partnerships.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              aria-label="WhatsApp"
              className="size-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#2C7A7B] transition-colors"
            >
              <MessageCircle size={17} />
            </a>
            <a
              href="#"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="size-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#2C7A7B] transition-colors"
            >
              <Instagram size={17} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              data-testid="footer-facebook"
              className="size-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#2C7A7B] transition-colors"
            >
              <Facebook size={17} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#7A8F6B]">Explore</div>
          <ul className="mt-5 space-y-3 text-[#F4EDE4]/80">
            <li><a href="#packages" className="hover:text-white">Packages</a></li>
            <li><a href="#services" className="hover:text-white">Services</a></li>
            <li><a href="#why" className="hover:text-white">Why Choose Us</a></li>
            <li><a href="#upcoming" className="hover:text-white">Upcoming</a></li>
            <li><a href="#contact" className="hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#7A8F6B]">Get in touch</div>
          <ul className="mt-5 space-y-3">
            <li className="flex items-center gap-3 text-[#F4EDE4]/85">
              <Mail size={16} className="text-[#7A8F6B]" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a>
            </li>
            <li className="flex items-center gap-3 text-[#F4EDE4]/85">
              <Phone size={16} className="text-[#7A8F6B]" />
              <a href={`tel:+${BRAND.whatsappNumber}`} className="hover:text-white">{BRAND.phoneDisplay}</a>
            </li>
            <li className="flex items-center gap-3 text-[#F4EDE4]/85">
              <MessageCircle size={16} className="text-[#7A8F6B]" />
              <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                WhatsApp · {BRAND.whatsappDisplay}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="text-sm text-[#F4EDE4]/60">
          © 2024 DreamFly Travels. All rights reserved.
        </div>
        <div className="text-xs text-[#F4EDE4]/50">
          Designed for travellers who notice the details.
        </div>
      </div>
    </footer>
  );
}
